import React, { useEffect, useState } from 'react';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from '../../constants/server.constant';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';

const Statistics = () => {
    const [userList, setUserList] = useState([]);
    const [isAction, setIsAction] = useState(true);
    const userId = localStorage.getItem("userId");
    useEffect(() => {
        window.scrollTo(0, 0);
        axiosInstance.get(API_HOST + "/referral/getrefrralusers/" + userId, axiosRequestWithAuth)
            .then(resp => {
                resp = resp.data;
                let list = [];
                for(let i = 0; i < resp.length; i++) {

                    let d = new Date(resp[i].user.createdOn);
                    var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
                    let createdDate = d.toLocaleString("en", options);
                    let users = {
                        "userEmail": resp[i].user.email,
                        "credits": (Number(resp[i].credits) / 100).toFixed(2),
                        "status": resp[i].user.emailVerify == 1 ? "Active" : "Inactive",
                        "date": createdDate
                    };
                    list.push(users);
                }
                sortdataBasedOnKey(list, "date", "ascending");


            })
            .catch(error => {
                setIsAction(false);
                console.log(error);
            });
    }, []);
    const sortData = (event, source) => {
        let toSort;
        let bool1 = $(event.currentTarget).find('.sort_icon').hasClass('toggle_sort');
        if(bool1) {
            $(event.currentTarget).find('.sort_icon').removeClass('toggle_sort');
            toSort = "ascending";
        }
        else {
            let bool2 = $(event.currentTarget).find('.sort_icon').hasClass('active');
            if(bool2) {
                $(event.currentTarget).find('.sort_icon').addClass('toggle_sort');
                toSort = "descending";
            }
            else {
                if($('.sort_icon').hasClass('toggle_sort')) {
                    $('.sort_icon').removeClass('active toggle_sort');
                }
                if($('.sort_icon').hasClass('active')) {
                    $('.sort_icon').removeClass('active ');
                }
                $(event.currentTarget).find('.sort_icon').addClass('active toggle_sort');
                toSort = "descending";
            }
        }
        sortdataBasedOnKey(userList, source, toSort);
    };

    const sortdataBasedOnKey = (data, key, order) => {
        let sortedList = [...data];
        if(key === "date") {
            sortedList.sort((a, b) => {

                let curr = new Date(a[key]);
                let next = new Date(b[key]);

                if(order == "descending") {
                    return next - curr;
                }
                else {
                    return curr - next;
                }
            });
        }
        else {
            sortedList.sort((a, b) => {
                let curr = a[key];
                let next = b[key];
                if(order == "descending") {
                    return (curr < next) ? -1 : ((curr > next) ? 1 : 0);
                }
                else {
                    return (curr > next) ? -1 : ((curr < next) ? 1 : 0);
                }
            });
        }

        setUserList(sortedList);
        setIsAction(false);
    };
    return (
        <React.Fragment>
            <div className="full_page_loader" style={ { display: isAction ? 'block' : 'none' } }>
                <div className="loader_icon"></div>
            </div>
            <section className="referralModule_wrapper ">
                <div className="statistics_section">
                    <h2 class="heading_title">View the statistics data for your referral program</h2>

                    <div className="statistics_table">
                        <div className="tabular_data_wrap statisticsTable">
                            <div className="table_header">
                                <ul>
                                    <li className="th">
                                        <div className="col col1" onClick={ (e) => sortData(e, "userEmail") }>
                                            <div className="header_sort_wrap">Referred Email Address
                                                <span className="sort_icon"></span>
                                            </div>
                                        </div>
                                        <div className="col col2" onClick={ (e) => sortData(e, "status") }>
                                            <div className="header_sort_wrap">Status
                                                <span className="sort_icon"></span>
                                            </div>
                                        </div>
                                        <div className="col col3" onClick={ (e) => sortData(e, "date") }>
                                            <div className="header_sort_wrap">Created On
                                                <span className="sort_icon active"></span>
                                            </div>
                                        </div>
                                        <div className="col col4" onClick={ (e) => sortData(e, "credits") }>
                                            <div className="header_sort_wrap">Credits
                                                <span className="sort_icon"></span>
                                            </div>
                                        </div>

                                    </li>
                                </ul>
                            </div>
                            <div className="table_data">
                                <ul>
                                    { userList.length <= 0 ? <li className="tr table_data_empty">
                                        <div className="outer_empty_wrap">
                                            <div className="inner_empty_wrap">
                                                <div className="svg_wrap empty_icon usersCreate_empty"></div>
                                                <p className="empty_title">No data found</p>
                                            </div>
                                        </div>
                                    </li> :
                                        userList.map((user, key) =>
                                            <li className="tr">
                                                <div className="col col1" data-for={ user.userEmail } data-tip>{ user.userEmail }</div>
                                                { user.userEmail.length > 52 ?
                                                    <ReactTooltip id={ user.userEmail } effect='solid' place='top' > { user.userEmail }</ReactTooltip> : "" }
                                                <div className="col col2">{ user.status }</div>
                                                <div className="col col3">{ user.date } </div>
                                                <div className="col col4">${ user.credits }</div>

                                            </li>
                                        )
                                    }

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default Statistics;